<template>
    <Tree :data="baseData"  
     @on-select-change="getNodes"></Tree>
</template>
<style>
    .ivu-tree-title{
        width:200px;
        text-align: left;
    }
</style>
<script>
    export default {
        data () {
            return {
                baseData: [],
                ctime:{}
            }
        },
        props:['deptData','selectedId'],
        watch:{
            'selectedId': function(n,o){
                // this.getTree();
                var len = this.deptData.length;
                if(len !== 0){
                    this.getTree();
                }
            },
             'deptData':function(n,o){
                var len = this.deptData.length;
                // console.log(len)
                if(len !== 0){
                    this.getTree()
                }
            }
        },
        // mounted(){
        //     var ctime = new Object();
        //     // console.log(this.deptData)
        //     // console.log(this.deptData.length)
        //     // console.log(len)
        //     var len = this.deptData.length;
        //     // console.log(len)
        //     if(len == 0){
        //                var vue = this;
        //                ctime = setInterval(function(){
        //                 vue.getTree()
        //                 // location.reload()
        //                     // if(vue.deptData.length !== 0){
        //                     //     // console.log(1)
        //                     //     // setTimeout(function(){
        //                     //         // clearInterval(ctime)
        //                     //     // },5000)
        //                     // }
                            
        //                 }, 8000 )
        //     }
        // },
        methods:{
            getTree(){
                this.baseData = [];//初始化
                // console.log(this.deptData)
                // console.log(this.deptData)
                var start = new Date().getTime();//起始时间
                //准备数据
                var data = this.deptData;
                let treedata = []
                //查找最顶层
                let len = data.length
                var selectArr = this.selectedId;
                for(let j=0;j<len;j++){
                    data[j].expand = false
                    // console.log(data[j])
                    data[j].title = data[j].name
                    if(data[j].parentId == "0"){

                            if(selectArr !== data[j].menuId ) {
                                treedata.push({
                                    "expand":true,
                                    "title":data[j].name,
                                    "menuId":data[j].menuId,
                                    
                                   })    
                               
                            }else{
                                treedata.push({
                                    "expand":true,
                                    "title":data[j].name,
                                    "menuId":data[j].menuId,
                                    "selected":true
                                })

                            }
                        
                    }
                }
                console.log(treedata)
                // 找到跟最高层id相关的子子孙孙，并给子孙添加lev
                var treedataLevs =[]
                for(let h=0,ls=treedata.length;h<ls;h++){
                    // console.log(treedata[h].menuId)
                    treedataLevs.push({
                        treedataLev:sonsTree(data,treedata[h].menuId)
                    })
                }
                // console.log(treedataLevs)
                for(let p=0,lq=treedataLevs.length;p<lq;p++){
                    var treedataLev = treedataLevs[p].treedataLev
                    // console.log(treedataLev)

                    //找到最高层的lev
                    var maxLev = 0
                    for(let i=0,lt=treedataLev.length;i<lt;i++){
                        
                        if(parseInt(treedataLev[i].lev) > 
                            maxLev){
                            maxLev = parseInt(treedataLev[i].lev)
                        }else{
                            maxLev = maxLev
                        }
                    }
                    // console.log(maxLev)
                    //比较当前层和上一层的数据，然后做处理
                    var needLev = maxLev
                    var maxLevTree = []
                    var maxLevTreePrev = []
                    for(let m=0;m<maxLev;m++){
                        maxLevTree = getLevArr(treedataLev,needLev)
                        maxLevTreePrev = getLevArr(treedataLev,needLev-1)
                        for(var j=0,lp=maxLevTreePrev.length;j<lp;j++){
                            maxLevTreePrev[j].expand = true;
                            maxLevTreePrev[j].children = new Array()
                            // console.log(selectArr)
                            // console.log(maxLevTreePrev[j].menuId)
                                if(selectArr == maxLevTreePrev[j].menuId){
                                        maxLevTreePrev[j].selected = true;
                                       
                                }
                            for(var i=0,lm=maxLevTree;i<lm.length;i++){

                                if(maxLevTree[i].parentId == maxLevTreePrev[j].menuId){
                                    maxLevTreePrev[j].children.push(maxLevTree[i])
                                }
                            }
                        }
                        needLev--
                    }
                    treedata[p].children = maxLevTreePrev
                }
                console.log(treedata)
                this.baseData = treedata;
                // //找出同一级的数据
                function getLevArr(arr,lev){
                    var newarr = []
                    for(let i=0,la=arr.length;i<la;i++){
                        //这里对arr 的children 做处理
                        arr.children = new Array()
                        if(parseInt(arr[i].lev) == lev){
                            newarr.push(arr[i])
                        }
                    }
                    return newarr
                }
                // // //给每个数据添加一个lev
                function sonsTree(arr,id){
                    var temp = [],lev=0;
                    var forFn = function(arr, id,lev){
                        for (var i = 0; i < arr.length; i++) {
                            var item = arr[i];
                            if (item.parentId == id) {
                                item.lev=lev;
                                temp.push(item);
                                forFn(arr,item.menuId,lev+1);
                            }
                        }
                    };
                    forFn(arr, id,lev);
                    return temp;
                }
                var end = new Date().getTime();//结束时间
                console.log("Tree初始化的时间是"+(end - start)+"ms")//返回函数执行需要时间
            },
            getNodes:function(node){
                console.log(node[0])
                // console.log('node'+node.length)
                 var data = {
                        name:node[0].title,
                        menuId:node[0].menuId
                    };
                
                // if(node.length !== 0){
                   
                //     node.forEach(r=>{  
                //         data.name.push(r.name)
                //         data.menuId.push(r.menuId)
                //     }) 
                // }
                // console.log(data)
                this.$emit('getTreeOne',data);
                // console.log(this.$refs.tree.getCheckedNodes())
                // console.log(this.$refs.tree.getSelectedNodes())
            }
        },
        created:function(){
            this.getTree()
        }
    }
</script>



// WEBPACK FOOTER //
// treeOneMenu.vue?d323fac2